import { AutocompleteOption, AutoCompleteMultiSearch } from '@bloomays-lib/ui.shared';

export type MissionOption = AutocompleteOption & {
  clientSocietyRecordId?: string;
  clientBillingSocietyRecordId?: string;
};

export type MissionSearchAutoCompleteProps = {
  label: string;
  placeholder: string;
  value: MissionOption[];
  disabled: boolean;
  onChange: (missions: MissionOption[]) => void;
  collectMissions: (input: string) => Promise<MissionOption[]>;
  loading: boolean;
};

export const MissionSearchAutoComplete = ({
  label,
  placeholder,
  value,
  disabled,
  onChange,
  collectMissions,
  loading,
}: MissionSearchAutoCompleteProps) => (
  <AutoCompleteMultiSearch
    label={label}
    placeholder={placeholder}
    value={value}
    disabled={disabled}
    loading={loading}
    onChange={onChange}
    collectOptions={collectMissions}
  />
);

export default MissionSearchAutoComplete;
